module.exports = __webpack_public_path__ + "static/media/hall-C-2026.92b544c9.svg";